<template>
  <div class="salary">
    <div class="divButtonRigth" style="margin-bottom: 20px">
      <el-button type="primary" size="small" @click="reOnClick()">预览222</el-button>
      <el-button type="primary" size="small" @click="reOnClick()">返回</el-button>
    </div>
    <div class="customer-info">
      <div class="customer-info-item">
        <div class="customer-info-title">
          <!--图标-->
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-qiyexinxi" />
          </svg>
          <span>基础信息</span>
        </div>
      </div>
      <div class="editForm">
        <el-form label-width="200px" :model="form" ref="templateForm" :rules="rules">
          <el-row>
            <el-col span="22">
              <el-form-item label="工资单名称" prop="payrollName">
                <el-input v-model="form.payrollName" placeholder="请输入工资单名称" />
              </el-form-item>
            </el-col>

            <el-col span="22">
              <el-form-item label="空值是否显示" prop="ifNull">
                <el-select  v-model="form.ifNull" placeholder="请选择">
                  <el-option key="0" value="0" label="否"></el-option>
                  <el-option key="1" value="1" label="是"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col span="22">
              <el-form-item label="是否显示双语" prop="twoLanguage">
                <el-select  v-model="form.twoLanguage" placeholder="请选择">
                  <el-option key="0" value="0" label="否"></el-option>
                  <el-option key="1" value="1" label="是"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col span="22">
              <el-form-item label="适用机构" prop="remarks">
                <el-input  v-model="form.remarks"  placeholder="请输入内容" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="customer-info">
      <div class="customer-info-item">
        <div class="customer-info-title">
          <!--图标-->
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-qiyexinxi" />
          </svg>
          <span>项目设置</span>
        </div>
        <div class="customer-info-button">
          <el-switch v-model="showSys" active-text="显示系统分类"></el-switch>
        </div>
      </div>
      <div
        class="salaryItem"
        v-for="(list,index) in form.lists"
        :key="list.id"
      >
        <el-row class="salaryItemHeader">
          <el-col class="salaryItemHeaderL" :span="4">{{list.setName}}</el-col>
          <el-col class="salaryItemHeaderC" :span="16">{{list.remark}}</el-col>
          <!--自定义-->
          <el-col class="salaryItemHeaderR" :span="4">
            <!--编辑-->
            <div class="salaryCheck" v-if="!isSysItem(list)" @click="editType(index)">
              <!--图标-->
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-qiyexinxi" />
              </svg>
            </div>
            <!--可选目录-->
            <el-popover
              class="salaryCheck"
              :class="{salaryCheckActve:popVisible[index].visible}"
              popper-class="salaryCheckPop"
              placement="bottom"
              width="120"
              v-loading="loading"
              visible-arrow="false"
              v-model="popVisible[index].visible"
            >
              <div class="salaryCheckBox">
                <div class="salaryChecks">
                  <el-checkbox-group v-model="checkedList[index]" >
                    <el-checkbox @change="changeItem(list,index)" v-for="list in checkLists[index].checkList" :label="list.itemName" :key="list.id">{{list.itemName}}</el-checkbox>
                  </el-checkbox-group>
                </div>
                <div class="addCheck" @click="addItem(index)">＋ 添加自定义项</div>
              </div>
              <svg class="icon" aria-hidden="true" slot="reference">
                <use xlink:href="#icon-qiyexinxi" />
              </svg>
            </el-popover>
            <!--删除-->
            <div class="salaryCheck"  v-if="!isSysItem(list)" @click="deleteType(index)">
              <!--图标-->
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-qiyexinxi" />
              </svg>
            </div>
            <!--展开-->
            <div class="salaryShow" v-if="opens[index].open" @click="changeOpen(index)">
              <!--图标-->
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-zhankaizhuangtai" />
              </svg>
            </div>
            <!--收起-->
            <div class="salaryShow" v-else @click="changeOpen(index)">
              <!--图标-->
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-shouqizhuangtai" />
              </svg>
            </div>
          </el-col>
        </el-row>
        <div class="salaryItemContent" v-show="opens[index].open" v-if="list.wageItemList">
          <!-- <el-row
            class="salaryLine"
            v-for="(item,itemIndex) in list.wageItemBOList"
            :key="item.id"
            v-if="( item.fixed === 1&&showSys||item.fixed !== 1 ) && !item.isDelete"
          > -->
          <el-row class="salaryLine" v-for="(item,itemIndex) in list.wageItemList" :key="item.id"  v-if="isSysItem(item)&&showSys||!isSysItem(item)">
            <el-col :span="4">
              <div class="salaryTitle">
                <el-tooltip content="系统项（不可编辑）" effect="light" placement="top" v-if="item.tenantId === '0'">
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-qiyexinxi" />
                  </svg>
                </el-tooltip>
                <div v-else class="zhanwei"></div>
                <span>{{item.itemName}}</span>
              </div>
            </el-col>
            <el-col :span="9">
              <div class="salaryExplain">{{item.remark}}</div>
            </el-col>
            <el-col :span="9">
              <div
                class="salaryFormula hasFormula"
                v-if=" item.isFormula =='10020002' || ( item.isFormula == '10020001' && item.wageFormula)"
              >
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-qiyexinxi" />
                </svg>

                <span v-if="item.isFormula =='10020002'">固定值</span>
                <span v-if="item.wageFormula">已设置：{{item.wageFormula.formulaZh}}</span>
                <!-- <span >固定项</span> -->
              </div>
              <div class="salaryFormula" v-else>
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-qiyexinxi" />
                </svg>
                <span @click="showFormulaDialog(index,itemIndex)">点击设置公式</span>
              </div>
            </el-col>
            <el-col :span="2">
              <div class="salaryBtn">
                <!--编辑-->
                <svg  class="icon salaryBtnEdit" aria-hidden="true"  v-if="!isSysItem(item)" @click="salaryEdit(index,itemIndex)" >
                  <!-- <svg  class="icon salaryBtnEdit" aria-hidden="true" @click="salaryEdit(index,itemIndex)" >-->
                  <use xlink:href="#icon-qiyexinxi" />
                </svg>
                <!--删除-->
                <svg class="icon" aria-hidden="true" v-if="!isSysItem(item)"  @click="deleteData(index,itemIndex)" >
                  <use xlink:href="#icon-qiyexinxi" />
                </svg>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="addItem" @click="addType">
      <svg class="icon" aria-hidden="true">
        <use xlink:href="#icon-qiyexinxi" />
      </svg>
      <span>添加自定义分类</span>
    </div>
    <el-row>
      <el-col :span="12" :offset="6">
        <div class="center marginTop30 marginBottom20">
          <el-button type="primary" size="mini" @click="$router.back(-1)">
            <svg class="icon" aria-hidden="true"> <use xlink:href="#icon-quxiao" /></svg>取消
          </el-button>
          <el-button type="primary" size="mini" @click="_saveTemplate"><svg class="icon" aria-hidden="true"> <use xlink:href="#icon-baocun" /> </svg> 提交
          </el-button>
        </div>
      </el-col>
    </el-row>

    <el-dialog title="设置自定义项目" :visible.sync="dialogItem" v-dialog-drag
               :close-on-click-modal="false"
               :close-on-press-escape="false" width="30%" :before-close="handleClose">
      <el-form
        :model="itemForm"
        ref="itemForm"
        :rules="releaseRules"
        class="editForm"
        label-width="80px"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item  label="项目名称" prop="itemName">
              <el-input :disabled="disableItem" v-model="itemForm.itemName" placeholder="请输入自定义项名称" />
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item  label="项目英文名" prop="itemEnName">
              <el-input :disabled="disableItem" v-model="itemForm.itemEnName" placeholder="请输入自定义项名称" />
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item  label="顺序" prop="itemName">
              <el-input :disabled="disableItem" v-model="itemForm.seq" placeholder="请输入自定义项名称" />
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="是否公式项" prop="isFormula">
              <el-radio-group v-model="itemForm.isFormula">
                <el-radio :label="'10020002'">固定项</el-radio>
                <el-radio :label="'10020001'">公式项</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="24">
            <el-form-item v-if="itemForm.isFormula=='10020001'" label="公式" prop="formulaZh">
              <el-input disabled v-model="itemForm.formulaZh" placeholder="公式项" />
            </el-form-item>
          </el-col> -->
          <el-col :span="24">
            <el-form-item :disabled="disableItem" label="值是否为空" v-if="this.tenantInfo.tenantId=='0'" prop="valueNotNull">
              <el-radio-group v-model="itemForm.valueNotNull">
                <el-radio :label="'10020002'">否</el-radio>
                <el-radio :label="'10020001'">是</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :disabled="disableItem" label="是否必有" v-if="this.tenantInfo.tenantId=='0'" prop="mustRequire">
              <el-radio-group v-model="itemForm.mustRequire">
                <el-radio :label="'10020002'">否</el-radio>
                <el-radio :label="'10020001'">是</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :disabled="disableItem" label="是否可编辑" v-if="this.tenantInfo.tenantId=='0'" prop="canModify">
              <el-radio-group v-model="itemForm.canModify">
                <el-radio :label="'10020002'">否</el-radio>
                <el-radio :label="'10020001'">是</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :disabled="disableItem" label="是否显示" v-if="this.tenantInfo.tenantId=='0'" prop="isShow">
              <el-radio-group v-model="itemForm.isShow">
                <el-radio :label="'10020002'">否</el-radio>
                <el-radio :label="'10020001'">是</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item  label="数据类型" prop="dataType">
              <el-select :disabled="disableItem" v-model="itemForm.valueType" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.codeItemId"
                  :label="item.codeItemName"
                  :value="item.codeItemId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item  label="项目描述" prop="remark">
              <el-input
                :disabled="disableItem"
                type="textarea"
                :rows="2"
                placeholder="请输入描述信息"
                maxlength="300"
                show-word-limit
                v-model="itemForm.remark"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogItemClose">取 消</el-button>
        <el-button type="primary" @click="dialogItemSave">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="添加自定义分类" :visible.sync="dialogType" width="30%"
               v-dialogDrag
               :close-on-click-modal="false"
               :close-on-press-escape="false" :before-close="handleClose">
      <el-form
        :model="typeForm"
        ref="typeForm"
        :rules="releaseRules"
        class="editForm"
        label-width="80px"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="分类名称" prop="setName">
              <el-input v-model="typeForm.setName" placeholder="请输入自定义分类名称" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="项目描述" prop="remark">
              <el-input
                type="textarea"
                :rows="2"
                placeholder="请输入描述信息"
                maxlength="300"
                show-word-limit
                v-model="typeForm.remark"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTypeClose">取 消</el-button>
        <el-button type="primary" @click="dialogTypeSave">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="添加公式" :visible.sync="dialogFormula" width="50%"
               v-dialogDrag
               :close-on-click-modal="false"
               :close-on-press-escape="false" :before-close="handleClose">
      <el-form
        :model="this.formulaInfo"
        ref="formulaInfo"
        :rules="releaseRules"
        class="editForm"
        label-width="80px"
      >

        <el-row>
          <el-col>
            <el-form-item label="公式顺序" prop="order"><el-input v-model="this.formulaInfo.order" /></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="公式" prop="formulaZh">
              <el-input v-model="this.formulaInfo.formulaZh" placeholder="请输入公式" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="运算符">
              <el-button
                size="mini"
                type="danger"
                v-for="item in this.formulaSymbolList "
                :key="item.codeItemId"
                @click="doOperate(item.codeItemName,item.codeItemName)"
              >{{item.codeItemName}}</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="数字">
              <el-button size="mini" type="primary" @click="doOperate('0','0')">0</el-button>
              <el-button size="mini" type="primary" @click="doOperate('1','1')">1</el-button>
              <el-button size="mini" type="primary" @click="doOperate('2','2')">2</el-button>
              <el-button size="mini" type="primary" @click="doOperate('3','3')">3</el-button>
              <el-button size="mini" type="primary" @click="doOperate('4','4')">4</el-button>
              <el-button size="mini" type="primary" @click="doOperate('5','5')">5</el-button>
              <el-button size="mini" type="primary" @click="doOperate('6','6')">6</el-button>
              <el-button size="mini" type="primary" @click="doOperate('7','7')">7</el-button>
              <el-button size="mini" type="primary" @click="doOperate('8','8')">8</el-button>
              <el-button size="mini" type="primary" @click="doOperate('9','9')">9</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="函数">
              <el-button
                size="mini"
                type="warning"
                v-for="item in this.formulaItemList "
                :key="item.codeItemId"
                @click="doOperate(item.codeItemName.replace('()','('),item.codeItemName.replace('()','('))"
              >{{item.codeItemName}}</el-button>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item v-for="item in this.form.lists" :key="item.id" :label="item.setName">
              <el-button
                v-for="item1 in item.wageItemList"
                :key="item1.id"
                size="mini"
                type="info"
                @click="doOperate(item1.itemName,item1.columnCode)"
              >{{item1.itemName}}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeFormulaDialog">取 消</el-button>
        <el-button type="primary" @click="saveFormula()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import {getCodeItemList,getPayrollItemList,saveTemplate } from "@/api/wage/salaryTemplate";
  import { mapGetters } from "vuex";
  export default {

    computed: {
      ...mapGetters([
        'dicts',
        'tenantInfo'
      ])
    },
    data() {
      return {
        name: "templateItem",
        loading: false,
        form: {
          id: this.$route.query.id, // 模板id
          payrollName: "",
          ifNull: "",
          twoLanguage: "",
          level: 0, // 级别
          lists: []
        },
        formula: "",
        dialogFormula: false, //是否显示公式设置对话框
        dialogItemOrder: false, // 模板项排序对话框
        dialogItem: false,
        dialogItemIndex: [],
        dialogTypeIndex: null,
        dialogType: false,
        popVisible: [], //下拉框是否显示
        opens: [], //是否收起
        showSys: true,
        disableItem: false,

        formulaItemList: [], //公式列表
        formulaSymbolList: [], //算术符号列表
        formulaList:[],
        formulaInfo:{
          index:0,
          itemIndex:0,
          formulaZh:'',
          formulaEn:'',
          order:1
        },

        checkLists: [], //模板候选项列表
        checkedList: [],  // 已选

        availableColumnCodes:[], //可用的用户自定义项的字段名
        rules: {
          templateName: [
            { required: true, message: "请输入模板名称", trigger: "blur" },
            { min: 4, max: 40, message: "长度在 4 到 40 个字符", trigger: "blur" }
          ],
          remarks: [{ max: 100, message: "长度不能大于100", trigger: "blur" }]
        },
        typeForm: {
          id: "",
          setName: "", //薪资集名称
          remark: "", // 备注
          showOrder: "", // 顺序
          wageItemList: [] //薪资项列表
        },
        itemForm: {
          id: "",
          itemName: "", //模板项名称
          valueType:"", //值类型，代码集
          valueNotNull: "", //值是否为空
          mustRequire: "", //是否必有
          canModify: "", //是否可编辑
          isFormula: "", //是否是公式项
          isShow: "", //是否显示
          codeSetId: "", // 代码集ID
          columnCode: "", //数据库字段
          dataSource: "", // 数据来源
          dataSourceTable: "", // 数据来源项表
          dataSourceItemId: "", //数据来源项
          formulaId:"",  //公式Id
          formulaZh:"", //中文公式
          formulaZh:"", //英文公式
          remark: ""
        },
        options: [] //项目类型代码集
      };
    },
    created() {
      console.log('加载用户信息L:')
      console.log(this.tenantInfo);

      this.init();
      this.getFormlaItem();
      this.getFormlaSymbol();
      this.getValueTypeCodes();
    },
    methods: {
      //保存公式
      _saveTemplate() {
        this.$refs['templateForm'].validate((valid) =>{
          if(valid){
            console.log(this.form)
            saveTemplate(this.form).then(res=>{
              let rs=res.data
              if(rs.code==0){
                this.$message.success('提交成功');
              }else{
                this.$message.error('提交失败')
              }
            })
          }else{
            this.$message.error('请输入模板名称')
          }
        })
      },

      changeOpen(index) {
        this.$set(this.opens[index], "open", !this.opens[index].open);
      },
      // 选择模板项候选项
      changeItem(checked,index) {
        // console.log(this.form.lists[index].wageItemList)
        console.log(checked)
        let arr=this.checkedList[index]
        console.log(arr)
        // debugger
        if(arr.includes(checked.itemName)){
          this.form.lists[index].wageItemList.push(checked)
        }else{
          let newArr=this.form.lists[index].wageItemList.filter((value)=>{return value.itemName!==checked.itemName})
          // console.log(newArr)
          this.$set(this.form.lists[index],'wageItemList',newArr)
        }
        // console.log(this.form.lists[index].wageItemList)
      },
      // 新增行
      addItem(index) {
        this.dialogItem = true;
        this.dialogItemIndex = [index, this.form.lists[index].wageItemList.length];
        // 对应数据置为空
        this.itemForm.id = null;
        this.itemForm.itemName = "";
        // debugger
        let length=this.form.lists[index].wageItemList.length
        if(length==0){
          this.itemForm.seq=1
        }else{
          // 去最后一个元素的顺序加1
          let lastSeq=this.form.lists[index].wageItemList[length-1].seq
          this.itemForm.seq=new Number(lastSeq)+1
        }
        console.log(this.form.lists[index].wageItemList)
        this.itemForm.id=""
        this.itemForm.valueType = "30370001"; //默认文本
        this.itemForm.itemEnName="" //模板项英文名
        this.itemForm.itemName="" //模板项名称
        this.itemForm.valueNotNull = "10020002"; //值不能为空： 否
        this.itemForm.mustRequire = "10020002"; // 是否必有： 否
        this.itemForm.canModify = "10020001"; // 是否可编辑： 是
        this.itemForm.isFormula = "10020002"; // 是否公式项：否
        this.itemForm.isShow = "10020002"; // 是否显示：否
        this.itemForm.codeSetId = "";
        this.itemForm.columnCode = "";
        this.itemForm.dataSource = "30380001"; // 数据来源：导入
        this.itemForm.dataSourceTable = "";
        this.itemForm.dataSourceItemId = "";
        this.itemForm.remark = "";
        // this.itemForm.wageFormula={}
        this.itemForm.tenantId= this.tenantInfo.tenantId // 租户ID
      },
      // 编辑行
      salaryEdit(index, itemIndex) {
        let tenantId=this.form.lists[index].wageItemList[itemIndex].tenantId
        console.log(tenantId)
        // this._disableItem(tenantId)
        this.$set(this.itemForm, "id", this.form.lists[index].wageItemList[itemIndex].id);
        this.$set( this.itemForm,"itemName",this.form.lists[index].wageItemList[itemIndex].itemName);
        this.$set( this.itemForm,"valueType",this.form.lists[index].wageItemList[itemIndex].valueType);
        this.$set( this.itemForm,"valueNotNull",this.form.lists[index].wageItemList[itemIndex].valueNotNull);
        this.$set( this.itemForm,"mustRequire",this.form.lists[index].wageItemList[itemIndex].mustRequire);
        this.$set( this.itemForm,"canModify",this.form.lists[index].wageItemList[itemIndex].canModify);
        this.$set( this.itemForm,"isFormula",this.form.lists[index].wageItemList[itemIndex].isFormula);
        this.$set( this.itemForm,"isShow",this.form.lists[index].wageItemList[itemIndex].isShow);
        this.$set( this.itemForm,"codeSetId",this.form.lists[index].wageItemList[itemIndex].codeSetId);
        this.$set( this.itemForm,"columnCode",this.form.lists[index].wageItemList[itemIndex].columnCode);
        this.$set( this.itemForm,"dataSource",this.form.lists[index].wageItemList[itemIndex].dataSource);
        this.$set( this.itemForm,"dataSourceTable",this.form.lists[index].wageItemList[itemIndex].dataSourceTable);
        this.$set( this.itemForm,"dataSourceItemId",this.form.lists[index].wageItemList[itemIndex].dataSourceItemId);
        // this.$set(this.itemForm,"formulaZh",this.form.lists[index].wageItemList[itemIndex].formulaZh);
        // this.$set(this.itemForm,"formulaEn",this.form.lists[index].wageItemList[itemIndex].formulaEn);
        this.$set(this.itemForm,"remark",this.form.lists[index].wageItemList[itemIndex].remark);
        this.$set(this.itemForm,"wageFormula",this.form.lists[index].wageItemList[itemIndex].wageFormula);
        this.$set(this.itemForm,"seq",this.form.lists[index].wageItemList[itemIndex].seq);
        this.$set(this.itemForm,"tenantId",this.form.lists[index].wageItemList[itemIndex].tenantId);

        this.dialogItem = true
        this.dialogItemIndex = [index,itemIndex]
      },
      // 保存一行
      dialogItemSave() {
        // 保存
        let [index, itemIndex] = this.dialogItemIndex;
        let data = {};
        data.id = this.itemForm.id;
        data.itemName = this.itemForm.itemName;
        data.valueType = this.itemForm.valueType;
        data.itevalueNotNullmType = this.itemForm.valueNotNull;
        data.mustRequire = this.itemForm.mustRequire;
        data.canModify = this.itemForm.canModify;
        data.isFormula = this.itemForm.isFormula;
        data.isShow = this.itemForm.isShow;
        data.codeSetId = this.itemForm.codeSetId;
        data.columnCode = this.itemForm.columnCode;
        data.dataSource = this.itemForm.dataSource;
        data.dataSourceTable = this.itemForm.dataSourceTable;
        data.dataSourceItemId = this.itemForm.dataSourceItemId;
        data.columnCode = this.availableColumnCodes.pop()
        data.remark = this.itemForm.remark;
        data.seq = this.itemForm.seq
        data.wageFormula=this.itemForm.wageFormula
        debugger
        data.tenantId=this.tenantInfo.tenantId
        // console.log(data)
        this.$set(this.form.lists[index].wageItemList, itemIndex, data);
        // debugger
        let temp=this.checkLists[index].checkList.filter(value=>{return value.itemName==data.itemName})
        if(!temp){
          this.checkLists[index].checkList.push(data)
          let arr=[]
          arr.push(data.itemName)
          this.checkedList.splice(index,0,arr)
          console.log(this.checkLists)
          console.log(this.checkedList)
        }

        this.$refs['itemForm'].resetFields();
        this.dialogItem = false;
      },

      // 删除一行
      deleteData(index, indexItem) {
        let columnCode=this.form.lists[index].wageItemList[indexItem].columnCode
        this.availableColumnCodes.push(columnCode)
        this.form.lists[index].wageItemList.splice(indexItem, 1);
      },

      //新增分类
      addType() {
        this.dialogType = true;
        this.dialogTypeIndex = this.form.lists.length;
      },

      // 保存分类
      dialogTypeSave() {
        let index = this.dialogTypeIndex;
        let data = {};
        data.id = this.typeForm.id;
        data.setName = this.typeForm.setName;
        data.seq = this.form.lists.length+1;
        data.tenantId= this.tenantInfo.tenantId
        data.remark = this.typeForm.remark;
        data.wageItemList = this.typeForm.wageItemList;
        if (!(data.wageItemList instanceof Array)) {
          data.wageItemList = new Array();
        }
        this.$set(this.form.lists, index, data);
        const checkList ={
          id: JSON.stringify(index),
          checkList:[]
        }
        this.$set(this.checkLists,index,checkList)
        console.log(this.checkLists)
        // debugger
        this.$set(this.popVisible, index, { visible: false });
        this.$set(this.opens, index, { open: true });
        this.$refs['typeForm'].resetFields();
        this.dialogType = false;
      },

      // 删除类别
      deleteType(index) {
        this.form.lists.splice(index,1)
        // 删除该索引下的候选项列表
        this.checkLists.splice(index,1)
        // 删除该索引下已选择的候选项列表
        this.checkedList.splice(index,1)
      },
      // 编辑类别
      editType(index) {
        console.log("编辑类别-----")
        this.dialogType = true;
        this.$set(this.typeForm, "id", this.form.lists[index].id);
        this.$set(this.typeForm, "setName", this.form.lists[index].setName);
        this.$set(this.typeForm, "remark", this.form.lists[index].remark);
        // this.$set(this.typeForm, "self", this.form.lists[index].self);
        this.$set(this.typeForm, "wageItemList", this.form.lists[index].wageItemList);
        this.dialogTypeIndex = index;
        console.log("编辑后的薪资项信息"+this.form.lists)
      },

      closeFormulaDialog: function(){
        this.dialogFormula=false
      },
      dialogItemClose() {
        this.$refs.itemForm.resetFields();
        this.dialogItem = false;
      },
      dialogTypeClose() {
        this.$refs.typeForm.resetFields();
        this.dialogType = false;
      },

      showFormulaDialog: function(index,itemIndex){
        this.$set(this.formulaInfo,'index',index)
        this.$set(this.formulaInfo,'itemIndex',itemIndex)
        // debugger
        // console.log('---------------'+this.formulaInfo)
        this.dialogFormula=true
      },

      //保存公式
      saveFormula(){
        // debugger
        console.log(this.formulaInfo)
        let index=this.formulaInfo.index
        let itemIndex=this.formulaInfo.itemIndex
        let formula={
          formulaZh: this.formulaInfo.formulaZh,
          formulaEn: this.formulaInfo.formulaEn,
        }

        let length=this.formulaList.length
        // console.log(index+':'+itemIndex)
        if(this.formulaList.length==0){
          formula.seq=1
        }else{
          formula.seq=this.formulaList[length-1].seq+1
        }
        // debugger
        console.log(formula)
        this.$set(this.form.lists[index].wageItemList[itemIndex],'wageFormula',formula)
        // this.$set(this.form.lists[index].wageItemList[itemIndex],'formulaEn',formulaEn)
        console.log(this.form)
        this.dialogFormula=false
        this.$refs['formulaInfo'].resetFields()
        this.formulaList.push(formula)
      },
      doOperate(value1,value2) {
        // debugger
        if (value1 === "C") {
          this.$set(this.formulaInfo,'formulaZh',"")
          this.$set(this.formulaInfo,'formulaEn',"")
        } else {
          this.$set(this.formulaInfo,'formulaZh',this.formulaInfo.formulaZh+value1)
          this.$set(this.formulaInfo,'formulaEn',this.formulaInfo.formulaEn+value2)
        }
      },
//获取函数项
      getFormlaItem(){
        getCodeItemList('3025').then(res=>{
          let rs=res.data
          // debugger
          if(rs.code==0){
            this.formulaItemList=rs.data
            // console.log('a'+ JSON.stringify(this.formulaItemList))
          }else{
            this.$message.error('获取公式项出现问题')
          }
        })
      },
      // 获取模板项数据类型
      getValueTypeCodes: function(){
        getCodeItemList('3037').then(res=>{
          let rs=res.data
          console.log("3037----"+rs)
          if(rs.code==0){
            // this.options=
            if(this.tenantInfo.tenantId!='0'){
              /*let arr=rs.data.filter(value=>{return value.codeItemId=='30370003'})
              let arr1=rs.data.filter(value=>{return value.codeItemId=='30370001'})
              arr[0].codeItemName='数值'
              arr.push(arr1[0])
              // console.log(arr)
              this.options=arr*/
              this.options=rs.data
            }else{
              this.options=rs.data
            }
            // console.log('a'+ JSON.stringify(this.formulaItemList))
          }else{
            this.$message.error('获取值类型出现问题')
          }
        })
      },
      // 获取公式符号
      getFormlaSymbol(){
        getCodeItemList('9241').then(res=>{
          let rs=res.data;
          if(rs.code==0){
            this.formulaSymbolList=rs.data
            console.log('运算数据1-----'+ this.formulaSymbolList)
            console.log('运算符号-----'+ JSON.stringify(this.formulaSymbolList))
          }else{
            this.$message.error('获取公式项出现问题')
          }
        })
      },

      isSysItem: function(item){
        if(item.tenantId==='0'){
          return true
        }else{
          return false
        }
      },

      reOnClick() {
        const query = {}
        this.$router.push({ path: '/wageSet/step3', query});
      },
      // _disableItem: function(tenantId){
      //   let currTenantId=this.tenantInfo.id
      //   if(tenantId!=currTenantId){
      //     this.disableItem=true
      //   }
      // },
      init() {
        console.log('模板初始化开始')
        // 获取信息
        let templateId=this.$route.query.id
        console.log("templateId-----"+templateId)
        getPayrollItemList(templateId).then(res => {
          console.log("============");
          // debugger
          // console.log(res)
          let rs=res.data.data
          console.log(rs)
          // 模板基础信息
          let template=rs.templateInfo
          this.form.templateName=template.templateName
          this.form.remarks= template.remarks
          // 模板项列表
          this.form.lists = template.lists;
          // 模板候选项列表
          this.checkLists=rs.checkLists

          console.log("form----"+this.form)
          console.log(this.checkLists)

          const len = this.form.lists.length;
          console.log(len)
          for (var i = 0; i < len; i++) {
            this.popVisible.push({ visible: false });
            this.opens.push({ open: true });
          }


          this.form.lists.forEach(value=>{
            let arr=new Array()
            value.wageItemList.forEach(value=>{
              arr.push(value.itemName)
              if(value.isFormula=='10020001'){
                this.formulaList.push(value.wageFormula)
              }
            })
            this.checkedList.push(arr)
          })

          this.availableColumnCodes=rs.customColumnCodes

          console.log('已选中列表：')
          console.log(this.checkedList)
          console.log('------------------------------')

          console.log('候选列表：')
          console.log(this.checkLists)
          console.log('------------------------------')

          console.log('公式列表：')
          console.log(this.formulaList)
          console.log('------------------------------')

          /* console.log('自定义ColumnCodes：')
           console.log(this.availableColumnCodes)
           console.log('------------------------------')*/
        });
      }
    }
  };
</script>
<style  scoped>
  .el-switch {
    margin-top: 0;
  }
  .salaryItem {
    padding: 0 20px;
  }
  .salaryItemHeader {
    display: flex;
    margin-top: 20px;
    background-color: #efefef;
    line-height: 40px;
    color: #999;
    font-size: 16px;
    padding-left: 34px;
    padding-right: 30px;
    display: flex;
    justify-content: space-between;
  }
  .salaryItemHeaderL {
    padding-left: 26px;
  }
  .salaryItemHeaderR {
    display: flex;
    justify-content: flex-end;
    color: #bbbbbb;
  }
  .salaryCheck {
    margin-right: 25px;
    padding: 0 5px;
  }
  .salaryCheckActve {
    background-color: #fff;
  }
  .salaryLine {
    border-bottom: 1px solid #efefef;
    line-height: 40px;
    padding: 0 30px 0 34px;
  }
  .salaryLine svg {
    font-size: 16px;
  }
  .salaryTitle svg {
    margin-right: 10px;
  }
  .salaryTitle .zhanwei {
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }
  .salaryTitle {
    color: #000000;
    font-size: 14px;
    display: flex;
    align-items: center;
  }
  .salaryTitle svg {
    color: #ff9600;
  }
  .salaryExplain {
    font-size: 12px;
    color: #999999;
    padding: 10px;
    line-height: 20px;
  }
  .salaryFormula {
    color: #008aff;
    font-size: 12px;
    cursor: pointer;
  }
  .hasFormula {
    color: #999999;
    cursor: auto;
  }
  .salaryFormula svg {
    margin-right: 10px;
    color: #008aff;
  }
  .hasFormula svg {
    color: #75cf00;
  }
  .salaryBtn {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 40px;
    color: #008aff;
  }
  .salaryBtnEdit {
    margin-right: 30px;
  }
  .salaryBtn svg {
    cursor: pointer;
  }
  .salaryItemHeaderC {
    color: #999999;
    font-size: 12px;
  }
  .salaryItemHeaderR div {
    cursor: pointer;
    margin-right: 30px;
  }
  .salaryItemHeaderR div:last-child {
    margin-right: 0px;
  }

  .addItem {
    margin: 20px auto 0;
    width: 160px;
    height: 30px;
    background-color: #dddddd;
    border-radius: 20px;
    font-size: 12px;
    color: #008aff;
    align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .addItem svg {
    margin-right: 10px;
    font-size: 16px;
  }
  .salaryChecks >>> .el-checkbox {
    display: flex;
    align-items: center;
    margin-right: 0;
  }
  .salaryChecks >>> .el-checkbox__label {
    line-height: 26px;
    color: #000000;
    font-size: 14px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 120px;
  }
  .salaryChecks >>> .el-checkbox__input {
    margin-top: 2px;
  }
  .addCheck {
    cursor: pointer;
    width: 120px;
    height: 30px;
    font-size: 12px;
    color: #008aff;
    background: #efefef;
    border-radius: 20px;
    text-align: center;
    line-height: 30px;
    margin: 10px auto 0;
  }
  .el-radio-group {
    margin: 0;
    height: 30px;
    display: flex;
    align-items: center;
  }
</style>
<style>
  .salaryCheckPop {
    min-width: 120px;
  }
  .salaryCheckPop .popper__arrow {
    display: none;
  }
  .el-button {
    margin-bottom: 10px;
  }
</style>
